/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Faq_A5Inputs */

const en_csv_to_json_faq_a5 = /** @type {(inputs: Csv_To_Json_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The first row is always treated as the header. If your CSV has no header, add column names as the first row before converting.`)
};

const ko_csv_to_json_faq_a5 = /** @type {(inputs: Csv_To_Json_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`첫 번째 행은 항상 헤더로 처리됩니다. CSV에 헤더가 없는 경우 변환 전에 첫 번째 행에 열 이름을 추가하세요.`)
};

const ja_csv_to_json_faq_a5 = /** @type {(inputs: Csv_To_Json_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初の行は常にヘッダーとして処理されます。CSVにヘッダーがない場合は、変換前に1行目に列名を追加してください。`)
};

/**
* | output |
* | --- |
* | "The first row is always treated as the header. If your CSV has no header, add column names as the first row before converting." |
*
* @param {Csv_To_Json_Faq_A5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_faq_a5 = /** @type {((inputs?: Csv_To_Json_Faq_A5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Faq_A5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_faq_a5(inputs)
	if (locale === "ko") return ko_csv_to_json_faq_a5(inputs)
	return ja_csv_to_json_faq_a5(inputs)
});